import { t } from 'i18next'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Button } from 'react-bootstrap'
import { MdLibraryAdd } from 'react-icons/md'
import WarehousesSelectModal from '../../WarehouseSelect/WarehousesSelectModal'

const WarehousesSelect = ({ setFormData, name , disabled, singleSelection}) => {
  const [showAddWarehousesModal, setShowAddWarehousesModal] = useState(false)
  const [selectedWarehouses, setSelectedWarehouses] = useState([])
  useEffect(() => {
    setFormData(prev => {
      const newValues = { ...prev }
      if (!selectedWarehouses.length) {
        delete newValues[name]
      } else {
        newValues[name] = selectedWarehouses.map(a => a.id)
      }
      return newValues
    })
  }, [setFormData, selectedWarehouses, name])

  return (
    <>
      <Button className="w-100 mb-3" onClick={() => setShowAddWarehousesModal(true)} disabled={disabled}><MdLibraryAdd className="me-3" />{t('reportConfig:addWarehouses')} {selectedWarehouses.length ? `(${selectedWarehouses.length})` : null}</Button>
      {showAddWarehousesModal
        ? <WarehousesSelectModal
        selectedWarehouses={selectedWarehouses}
          setSelectedWarehouses={setSelectedWarehouses}
          setShowAddWarehousesModal={setShowAddWarehousesModal}
          handleSave={() => setShowAddWarehousesModal(false)}
          singleSelection={singleSelection}
        />
        : null}
    </>

  )
}

export default WarehousesSelect